import OrganizationCategoryImportPage from './OrganizationCategoryImportPage';

export default OrganizationCategoryImportPage;
